"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LegendItemBoxColor = _interopRequireDefault(require("./LegendItemBoxColor.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LegendItemBoxColor = function LegendItemBoxColor(_ref) {
  var isNegative = _ref.isNegative,
    boxColor = _ref.boxColor,
    active = _ref.active;
  return /*#__PURE__*/_react["default"].createElement(_LegendItemBoxColor["default"], {
    isNegative: isNegative,
    boxColor: boxColor,
    style: {
      backgroundColor: isNegative ? '' : boxColor
    } // this is needed for the pdf export
    ,
    active: active,
    "data-testid": "legend-item-box-color"
  });
};
LegendItemBoxColor.defaultProps = {
  isNegative: false,
  active: false
};
LegendItemBoxColor.propTypes = {
  isNegative: _propTypes["default"].bool,
  boxColor: _propTypes["default"].string.isRequired,
  active: _propTypes["default"].bool
};
LegendItemBoxColor.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LegendItemBoxColor",
  "props": {
    "isNegative": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "boxColor": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = LegendItemBoxColor;
exports["default"] = _default;